/**
 * PH (菲律宾) 特性开关覆写
 * 命名规则同 diffconfig/config/featureFlags.ts：Module-Page-Feature
 */
export default {
  'Login-ForgotPassword-Show': true,
  'Login-NeedTermsAndPrivacy': true,
  'Login-UseAccountLogin': true,
  // 'Home-OrderTrend-Show': true,
  // 'Home-OrderParcelStatistics-Show': true,
  // 'Store-PrintLabel76x150-Enable': true,
  // 'Package-Return-Enable': true,
  // 'COD-Statistics-Show': true,
  // 'COD-AbnormalPayment-Show': true,
  'Address-NeedEmail-Enable': true,
  /** 头部是否需要下载中心 */
  'Header-NeedDownloadCenter-Enable': true,
  /** 头部是否需要快件跟踪 */
  'Header-NeedTracking-Enable': true,
  /** 面单打印字体包 */
  'Print-FontPackage-Enable': true,
  /** 头部显示学习中心入口 */
  'Header-LearningCenter-Show': true,
}
